export const PRODUCT_NAME = "Monyawn";
export const LEGAL_OWNER_NAME = "CAD Guardian LLC";
export const LEGAL_OWNER_COUNTRY = "United States";
export const LEGAL_OWNER_COPYRIGHT = `© ${new Date().getFullYear()} ${LEGAL_OWNER_NAME}. All rights reserved.`;

export const LEGAL_CONTACTS = {
  supportPath: "#support",
  supportEmail: "support@monyawn.com",
  privacyEmail: "privacy@monyawn.com",
  securityEmail: "security@monyawn.com",
  legalNoticeEmail: "legal@monyawn.com",
  dmcaAgent: "DMCA Agent, CAD Guardian LLC, legal@monyawn.com",
  postalNotice: "CAD Guardian LLC, United States",
  governingLaw: "Delaware, United States",
  venue: "State or federal courts located in Delaware, United States",
} as const;

export const LEGAL_REVIEW_FLAGS = {
  ownerDecision: "OWNER DECISION FINALIZED",
  counselReview: "COUNSEL REVIEW PENDING",
} as const;

export const THIRD_PARTY_PROCESSORS = [
  {
    name: "Supabase",
    purpose:
      "Optional cloud sync, authentication, and hosted Postgres/edge functions when configured.",
    data: "Account, user, opportunity, artifact, correspondence, story, task, and event records that the customer chooses to sync.",
  },
  {
    name: "OpenAI",
    purpose:
      "Optional AI story generation, structured signal extraction, and voice transcription when enabled by the user.",
    data: "Submitted prompts, transcript audio, artifacts, correspondence, and derived structured signals sent during a user-triggered AI request.",
  },
  {
    name: "Clerk",
    purpose: "Authentication and session management when Clerk login is enabled.",
    data: "User identity metadata, session tokens, and authentication event context required for secure sign-in.",
  },
  {
    name: "Anthropic",
    purpose: "Optional AI story generation when enabled by the user.",
    data: "Submitted prompts, artifacts, correspondence, and related structured context sent during a user-triggered AI request.",
  },
  {
    name: "Sentry",
    purpose:
      "Optional diagnostics and error monitoring when diagnostics are enabled and a DSN is configured.",
    data: "Technical error and performance metadata and replay-on-error artifacts with text masking enabled in current code.",
  },
] as const;

export const SECURITY_COMMITMENTS = [
  "Local-first storage is the default application posture.",
  "Sensitive support notes are excluded from exports unless the user explicitly enables export for that record and account policy permits it.",
  "Diagnostics are optional and can be disabled from the Privacy page.",
  "External AI processing occurs only when the user chooses an AI provider and triggers an AI action.",
  "We do not promise uninterrupted availability, vulnerability-free software, or formal certification absent a separate written commitment.",
] as const;

export const ACCEPTABLE_USE_RESTRICTIONS = [
  "Do not reverse engineer, decompile, scrape, mirror, or resell the platform except to the extent non-waivable law prohibits restriction.",
  "Do not use the platform to build, train, benchmark, or improve a competing service using protected platform materials, prompts, workflow structures, or exported proprietary materials beyond your permitted use.",
  "Do not submit unlawful, infringing, deceptive, malicious, or harmful content.",
  "Do not probe, scan, bypass, or interfere with security or access controls.",
  "Do not impersonate another person or misrepresent your authority to upload or share materials.",
] as const;
